var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3434 16.6896L17.3434 10.3096C17.3434 9.00295 15.9234 8.18295 14.7901 8.83629L12.0234 10.4296L9.25673 12.0296C8.1234 12.683 8.1234 14.3163 9.25673 14.9696L12.0234 16.5696L14.7901 18.163C15.9234 18.8163 17.3434 18.003 17.3434 16.6896Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 26C25.25 26.1381 25.3619 26.25 25.5 26.25C25.6381 26.25 25.75 26.1381 25.75 26L25.25 26ZM1.90735e-06 26C1.89528e-06 26.1381 0.111931 26.25 0.250002 26.25C0.388073 26.25 0.500002 26.1381 0.500002 26L1.90735e-06 26ZM0.500004 0.999998C0.500004 0.861927 0.388075 0.749998 0.250004 0.749998C0.111933 0.749998 4.10499e-06 0.861927 4.09292e-06 0.999998L0.500004 0.999998ZM25.75 1C25.75 0.861929 25.6381 0.75 25.5 0.75C25.3619 0.75 25.25 0.861929 25.25 1L25.75 1ZM0.500002 26L0.500004 0.999998L4.09292e-06 0.999998L1.90735e-06 26L0.500002 26ZM25.25 1L25.25 26L25.75 26L25.75 1L25.25 1Z",
    fill: "#B2BFC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBefore);
export default __webpack_public_path__ + "static/media/before.5e539c6dc1fd6a31043d4fc106e6f60f.svg";
export { ForwardRef as ReactComponent };